import { Group, Menu } from '@mantine/core';
import {
  IconCalendarEvent,
  IconDeviceFloppy,
  IconDotsCircleHorizontal,
  IconEye,
  IconFiles,
  IconTemplate,
  IconTrash,
} from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBookitupScope } from '../../../Service/Context/BookitupSubscriptionContext';
import DocumentLanguagePicker from '../../../Atoms/inputs/DocumentLanguagePicker';
import { Language } from '../../../Service/DocumentT';
import { useEventScope } from '../../../Service/hooks/useEventScope';
import ActionIconWithText from './ActionIconWithText';
import NavAddIcon from './NavAddIcon';

interface Props {
  addHandler: () => void;
  saveAsTemplate?: () => void;
  loadTemplate?: () => void;
  remove: () => void;
  showPreview: () => void;
  language?: Language | null;
  onLanguageChange?: (language: Language) => void;
}

const DocumentEditorFooter: FC<Props> = ({
  addHandler,
  saveAsTemplate,
  loadTemplate,
  remove,
  showPreview,
  language,
  onLanguageChange,
}) => {
  const { eventId, isEventScope } = useEventScope();
  const navigate = useNavigate();
  const { isScopeSelected: hasDocumentsScope } = useBookitupScope('DOCUMENTS');

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      {isEventScope && (
        <ActionIconWithText label="Details" onClick={() => navigate(`/events/${eventId}/details`)}>
          <IconCalendarEvent />
        </ActionIconWithText>
      )}
      {!isEventScope && (
        <ActionIconWithText label="Events" onClick={() => navigate('/')}>
          <IconCalendarEvent />
        </ActionIconWithText>
      )}
      <ActionIconWithText
        isVisible={hasDocumentsScope}
        label="Dateien"
        onClick={() => navigate(isEventScope ? `/events/${eventId}/documents` : '/documents')}
      >
        <IconFiles />
      </ActionIconWithText>
      <NavAddIcon onClick={addHandler} />
      <ActionIconWithText label="Vorschau" onClick={showPreview}>
        <IconEye />
      </ActionIconWithText>
      <Menu withArrow shadow="md" width={200} transition="slide-up" position="top-end">
        <Menu.Target>
          <div>
            <ActionIconWithText label="Mehr">
              <IconDotsCircleHorizontal />
            </ActionIconWithText>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          {loadTemplate && (
            <Menu.Item onClick={loadTemplate} icon={<IconTemplate size={16} />}>
              Vorlage auswählen
            </Menu.Item>
          )}
          {saveAsTemplate && (
            <Menu.Item onClick={saveAsTemplate} icon={<IconDeviceFloppy size={16} />}>
              Vorlage speichern
            </Menu.Item>
          )}
          <Menu.Divider />
          <DocumentLanguagePicker variant="menu-items" language={language} onLanguageChange={onLanguageChange} />
          <Menu.Divider />
          <Menu.Item color="red" onClick={remove} icon={<IconTrash size={16} />}>
            Löschen
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};

export default DocumentEditorFooter;
